import { render, staticRenderFns } from "./FormItemVar.vue?vue&type=template&id=401eecee"
import script from "./FormItemVar.vue?vue&type=script&lang=js"
export * from "./FormItemVar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports